// يبني مستند HTML لتقرير الحضور ويفتحه في نافذة طباعة (نفس تصميم تقرير الرواتب).
import { css } from "../payroll/reportTokens";
import { AL } from "./attReportLabels";
import { buttons, cards, header } from "./attReportHeader";
import { explain, footer, table, warning, pageCount } from "./attReportTable";
import { shareBar } from "../reports/shareBar";
import { pdfScript } from "../reports/pdfActions";
import { refLine } from "../reports/refLine";
import { openSharedReportWindow } from "../reports/openShared";
import { reportTitle } from "../reports/reportTitle";

export const buildAttendanceHtml = (data, lang = "ar", options = {}, share = null) => {
  const L = AL[lang === "en" ? "en" : "ar"];
  const rtl = lang !== "en";
  const title = share?.title || (options.custom ? L.titleCustom : L.titleMany);
  return `<!DOCTYPE html>
<html lang="${rtl ? "ar" : "en"}" dir="${rtl ? "rtl" : "ltr"}">
<head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><title>${title}</title><style>${css(Boolean(options.custom))}</style></head>
<body>
${buttons(L, share, options.pdfUrl)}
${refLine(share, L.reference)}
${header(data, L, options)}
${cards(data, L)}
${table(data, L)}
${explain(L)}
${warning(data, L)}
${footer(L, pageCount(data))}
${shareBar(share?.url, L.copied)}
${pdfScript(options.pdfUrl, title, L)}
</body></html>`;
};

export const openAttendanceWindow = (data, lang, options = {}) =>
  openSharedReportWindow({
    title: reportTitle(data, lang, { kind: "attendance", custom: options.custom }),
    win: options.win,
    ticket: options.ticket || null,
    pdfUrl: options.pdfUrl || null,
    ticketPromise: options.ticketPromise || null,
    opts: options,
    fileName: `attendance-${data.period_start || ""}`,
    lang,
    meta: {
      company: options.brand?.name,
      branch: data.branch_name || (lang === "en" ? "All branches" : "جميع الفروع"),
      branch_id: data.branch_id || null,
      period: `${data.period_start} → ${data.period_end}`,
    },
    build: (share) => buildAttendanceHtml(data, lang, options, share),
  });
